import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: () => import('@/view/home.vue')
    },
    {
      path: '/brand',
      name: 'brand',
      component: () => import('@/view/brand.vue')
    },
    {
      path: '/team',
      name: 'team',
      component: () => import('@/view/team.vue')
    },
    {
      path: '/matron/desc',
      name: 'matron_desc',
      component: () => import('@/view/matron/desc.vue')
    },
    {
      path: '/matron/users',
      name: 'matron_users',
      component: () => import('@/view/matron/users.vue')
    },
    {
      path: '/matron/user',
      name: 'matron_user',
      component: () => import('@/view/matron/user.vue')
    },
    {
      path: '/nurse/desc',
      name: 'nurse_desc',
      component: () => import('@/view/nurse/desc.vue')
    },
    {
      path: '/nurse/users',
      name: 'nurse_users',
      component: () => import('@/view/nurse/users.vue')
    },
    {
      path: '/nurse/user',
      name: 'nurse_user',
      component: () => import('@/view/nurse/user.vue')
    },
    {
      path: '/news/list',
      name: 'news_list',
      component: () => import('@/view/news/list.vue')
    },
    {
      path: '/news/detail',
      name: 'news_detail',
      component: () => import('@/view/news/detail.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/view/contact.vue')
    },
    {
      path: '/train',
      name: 'train',
      component: () => import('@/view/train.vue')
    },
    {
      path: '/promote',
      name: 'promote',
      component: () => import('@/view/promote.vue')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js